import { render, staticRenderFns } from "./FaceAuthenticationStatistics.vue?vue&type=template&id=6bbc1c7f"
import script from "./FaceAuthenticationStatistics.vue?vue&type=script&lang=js"
export * from "./FaceAuthenticationStatistics.vue?vue&type=script&lang=js"
import style0 from "./FaceAuthenticationStatistics.vue?vue&type=style&index=0&id=6bbc1c7f&prod&lang=less&scope=true"
import style1 from "./FaceAuthenticationStatistics.vue?vue&type=style&index=1&id=6bbc1c7f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports